import { render, staticRenderFns } from "./TotalProductsResultsTable.vue?vue&type=template&id=6899028a&scoped=true"
import script from "./TotalProductsResultsTable.vue?vue&type=script&lang=js"
export * from "./TotalProductsResultsTable.vue?vue&type=script&lang=js"
import style0 from "./TotalProductsResultsTable.vue?vue&type=style&index=0&id=6899028a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6899028a",
  null
  
)

export default component.exports